import type { ReferralFormValues } from '../../types';

import { ReferralDownloadButton } from './ReferralDownloadButton';
import { useReferralPdfGenerator } from './ReferralPdfGenerator';
import { ReferralSuccessScreen } from './ReferralSuccessScreen';

interface ReferralPdfDownloadProps {
  // Only need unifiedAppointmentId to fetch from API
  unifiedAppointmentId?: string;
  appointment?: any;
  disabled?: boolean;
  isDownloadStep?: boolean;
  hideDownloadButton?: boolean;
  // Keep formData for backward compatibility but it's no longer used
  formData?: ReferralFormValues;
  selectedPractice?: {
    practice_id: number;
    practice_name: string;
    referral_practice_address?: string;
    referral_practice_phone?: string;
  };
}

export const ReferralPdfDownload = ({
  unifiedAppointmentId,
  appointment,
  disabled = false,
  isDownloadStep = false,
  hideDownloadButton = false,
  // formData and selectedPractice are kept for backward compatibility but not used
  formData,
  selectedPractice,
}: ReferralPdfDownloadProps) => {
  const { generatePdf, isGenerating, isLoading, hasData } =
    useReferralPdfGenerator({
      unifiedAppointmentId,
      appointment,
    });

  const handleDownloadPdf = async () => {
    await generatePdf();
  };

  // If this is the download step, show the success screen with download button
  if (isDownloadStep) {
    return (
      <ReferralSuccessScreen hideDownloadButton={hideDownloadButton}>
        {!hideDownloadButton && (
          <ReferralDownloadButton
            onClick={handleDownloadPdf}
            disabled={disabled || isLoading || !hasData}
            loading={isGenerating}
            size="lg"
            variant="default"
            className="vai-bg-blue-600 hover:vai-bg-blue-700 vai-text-white vai-px-8 vai-py-4 vai-text-lg vai-font-semibold"
          />
        )}
      </ReferralSuccessScreen>
    );
  }

  // Regular button for other steps
  return (
    <ReferralDownloadButton
      onClick={handleDownloadPdf}
      disabled={disabled || isLoading || !hasData}
      loading={isGenerating}
      size="sm"
      variant="outline"
      className="vai-h-9"
    />
  );
};
